const MenuData = [
  {
    id: 0,
    title: 'Miso Soup',
    category: 'APPETIZERS',
    price: 3.00,
    img: '/images/No_image.JPG',
    desc: 'soy bean paste soup',
    },
    {
    id: 1,
    title: 'Edamame',
    category: 'APPETIZERS',
    price: 5.70,
    img: '/images/No_image.JPG',
    desc: 'boiled soya bean',
    },
    {
    id: 2,
    title: 'Gyoza(6pcs)',
    category: 'APPETIZERS',
    price: 7.00,
    img: '/images/No_image.JPG',
    desc: 'deep fried chicken & vegetable dumplings with gyoza sauce',
    },
    {
    id: 3,
    title: 'Vegetarian Gyoza(6pcs)',
    category: 'APPETIZERS',
    price: 6.00,
    img: '/images/No_image.JPG',
    desc: 'deep fried vegetable dumplings with gyoza sauce',
    },
    {
    id: 4,
    title: 'Vegetarian Spring Roll(6pcs)',
    category: 'APPETIZERS',
    price: 6.75,
    img: '/images/No_image.JPG',
    desc: 'deep fried vegetable spring roll 6pcs with spring roll sauce',
    },
    {
    id: 5,
    title: 'Shrimp Spring Roll(3pcs)',
    category: 'APPETIZERS',
    price: 9.50,
    img: '/images/No_image.JPG',
    desc: 'deep fried shrimp spring roll with spring roll sauce',
    },
    {
    id: 6,
    title: 'Agedashi Tofu(6pcs)',
    category: 'APPETIZERS',
    price: 6.75,
    img: '/images/No_image.JPG',
    desc: 'deep fried tofu with tempura sauce',
    },
    {
    id: 7,
    title: 'Sunomono Salad',
    category: 'APPETIZERS',
    price: 7.75,
    img: '/images/No_image.JPG',
    desc: 'cucumber, noodles & choice of shrimp, octopus, crab stick, real crab or avocado',
    },
    {
    id: 8,
    title: 'Wakame Salad',
    category: 'APPETIZERS',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: 'seaweed, sesame with sauce',
    },
    {
    id: 9,
    title: ' Goma Ae',
    category: 'APPETIZERS',
    price: 7.50,
    img: '/images/No_image.JPG',
    desc: 'boiled spinach with sesame sauce',
    },
    {
    id: 10,
    title: ' Maguro Goma Ae',
    category: 'APPETIZERS',
    price: 12.20,
    img: '/images/No_image.JPG',
    desc: 'tuna, avocado, spinach with sesame sauce, salmon available instead of tuna',
    },
    {
    id: 11,
    title: ' House Green Salad',
    category: 'APPETIZERS',
    price: 5.75,
    img: '/images/No_image.JPG',
    desc: 'mixed vegetable salad with house dressing',
    },
    {
    id: 12,
    title: ' Avocado Green Salad',
    category: 'APPETIZERS',
    price: 6.75,
    img: '/images/No_image.JPG',
    desc: 'mixed vegetable salad & avocado slices with house dressing',
    },
    {
    id: 13,
    title: ' Nacho Nachos(4pcs)',
    category: 'APPETIZERS',
    price: 9.95,
    img: '/images/No_image.JPG',
    desc: 'tuna, scallop, avocado mixed with sesame mayo and fish egg, Jalapeno,green onions on top',
    },
    {
    id: 14,
    title: ' Shrimp Tempura',
    category: 'APPETIZERS',
    price: 12.25,
    img: '/images/No_image.JPG',
    desc: '6pcs of shrimp',
    },
    {
    id: 15,
    title: ' Vegetable Tempura',
    category: 'APPETIZERS',
    price: 10.25,
    img: '/images/No_image.JPG',
    desc: '7pcs of mixed vegetable',
    },
    {
    id: 16,
    title: ' Yam tempura',
    category: 'APPETIZERS',
    price: 10.25,
    img: '/images/No_image.JPG',
    desc: '7pcs of yam',
    },
    {
    id: 17,
    title: ' Assorted Tempura',
    category: 'APPETIZERS',
    price: 15.20,
    img: '/images/No_image.JPG',
    desc: '3pcs of shrimp, 6pcs mixed vegetable',
    },
    {
    id: 18,
    title: ' Ring of Fire(6pcs)',
    category: 'APPETIZERS',
    price: 8.50,
    img: '/images/No_image.JPG',
    desc: ' bread squid with spicy house dressing',
    },
    {
    id: 19,
    title: ' Tuna Tataki',
    category: 'APPETIZERS',
    price: 16.00,
    img: '/images/No_image.JPG',
    desc: 'lightly grilled sesame blend on tuna ,or choice with salmon ',
    },
    {
    id: 20,
    title: ' Sushi Pizza',
    category: 'APPETIZERS',
    price: 13.75,
    img: '/images/No_image.JPG',
    desc: 'deep fried sushi rice, topped with salmon sashimi, avocado, tobiko, unagi sauce',
    },
    {
    id: 21,
    title: 'Special Fried Scallop(6pcs)',
    category: 'APPETIZERS',
    price: 9.75,
    img: '/images/No_image.JPG',
    desc: 'deep fried bread crumbs scallop with sweet washibi mayo sauce',
    },
    {
    id: 22,
    title: 'Bread Crab stick(6pcs)',
    category: 'APPETIZERS',
    price: 7.25,
    img: '/images/No_image.JPG',
    desc: 'deep fried bread Crab stick with sweet washibi mayo sauce',
    },
    {
    id: 23,
    title: 'Soft Shell Crab',
    category: 'APPETIZERS',
    price: 11.25,
    img: '/images/No_image.JPG',
    desc: 'deep fried soft shell crab for one',
    },
    {
    id: 24,
    title: 'Sushi rice',
    category: 'APPETIZERS',
    price: 3.20,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 30,
    title: 'Salmon Sashimi (atlantic Salmon 8pcs)',
    category: 'SASHIMI',
    price: 19.50,
    img: '/images/No_image.JPG',
    desc: 'additional sashimi $3.00 for each piece',
    },
    {
    id: 31,
    title: 'Salmon Sashimi Half (4pcs)',
    category: 'SASHIMI',
    price: 11.00,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 32,
    title: 'Tuna Sashimi (albacore tuna 8pcs)',
    category: 'SASHIMI',
    price: 19.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 33,
    title: 'Tuna Sashimi Half (4pcs)',
    category: 'SASHIMI',
    price: 11.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 34,
    title: 'Red Tuna Sashimi (aka maguro 6pcs)',
    category: 'SASHIMI',
    price: 15.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 35,
    title: 'White Tuna Sashimi (shiro maguro 6pcs)',
    category: 'SASHIMI',
    price: 14.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 36,
    title: 'Salmon & Tuna Sashimi (12pcs)',
    category: 'SASHIMI',
    price: 26.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 37,
    title: 'Salmon & Tuna Sashimi Half (6pcs)',
    category: 'SASHIMI',
    price: 16.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 38,
    title: 'Assorted Sashimi (12pcs)',
    category: 'SASHIMI',
    price: 23.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 40,
    title: 'Salmon (sake)',
    category: 'NIGIRI SUSHI',
    price: 6.25,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 41,
    title: 'Tuna (maguro)',
    category: 'NIGIRI SUSHI',
    price: 6.25,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 42,
    title: 'Red Tuna (aka maguro)',
    category: 'NIGIRI SUSHI',
    price: 7.25,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 43,
    title: 'White Tuna (shiro maguro)',
    category: 'NIGIRI SUSHI',
    price: 6.00,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 44,
    title: 'Fatty Salmon (sake toro)',
    category: 'NIGIRI SUSHI',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 45,
    title: 'Red Snapper (tai)',
    category: 'NIGIRI SUSHI',
    price: 6.00,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 46,
    title: 'Squid (ika)',
    category: 'NIGIRI SUSHI',
    price: 6.00,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 47,
    title: 'Scallop (hotategai)',
    category: 'NIGIRI SUSHI',
    price: 7.75,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 48,
    title: 'Surf Clam (hokkigai)',
    category: 'NIGIRI SUSHI',
    price: 6.00,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 49,
    title: 'Cooked Shrimp (ebi)',
    category: 'NIGIRI SUSHI',
    price: 5.50,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 50,
    title: 'Octopus (tako)',
    category: 'NIGIRI SUSHI',
    price: 5.60,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 51,
    title: 'BBQ Eel (unagi)',
    category: 'NIGIRI SUSHI',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 52,
    title: 'Smoked Salmon (smoked sake)',
    category: 'NIGIRI SUSHI',
    price: 5.60,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 53,
    title: 'Egg Omelet (tamago)',
    category: 'NIGIRI SUSHI',
    price: 5.25,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 54,
    title: 'Crab Meat (kani)',
    category: 'NIGIRI SUSHI',
    price: 4.75,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 55,
    title: 'Chopped Scallop (with mayo & fish egg)',
    category: 'NIGIRI SUSHI',
    price: 6.00,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 56,
    title: 'Tobiko (flying fish egg)',
    category: 'NIGIRI SUSHI',
    price: 6.00,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
    id: 57,
    title: 'Bean Curd Skin (inari)',
    category: 'NIGIRI SUSHI',
    price: 4.50,
    img: '/images/No_image.JPG',
    desc: '2pcs per order',
    },
    {
      id: 60,
      title: 'Paradise Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 14.50,
      img: '/images/No_image.JPG',
      desc: 'California roll base covered with sockeye salmon & mango {honey mango sauce}',
      },
      {
      id: 61,
      title: 'Rainbow Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 15.00,
      img: '/images/No_image.JPG',
      desc: 'California roll base covered with assorted sashimi on top',
      },
      {
      id: 62,
      title: 'Caterpillar Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 14.50,
      img: '/images/No_image.JPG',
      desc: 'Bbq eel, cucumber covered with avocado {unagi sauce and black sesame}',
      },
      {
      id: 63,
      title: 'Tiger Roll(6pcs)',
      category: 'SPECIAL ROLLS',
      price: 13.75,
      img: '/images/No_image.JPG',
      desc: 'California roll base covered with bolled shrimp & avocado',
      },
      {
      id: 64,
      title: 'Spider Roll(6pcs)',
      category: 'SPECIAL ROLLS',
      price: 14.75,
      img: '/images/No_image.JPG',
      desc: 'Deep fried soft shell crab, crab meat, avocado, cucumber, fish egg, mayo',
      },
      {
      id: 65,
      title: 'Firefly Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 13.00 ,
      img: '/images/No_image.JPG',
      desc: '2 pcs of shrimp tumpura, zucchint tempura, cream cheese, cucumber {spicy mayo, unagi sauce}',
      },
      {
      id: 66,
      title: 'Crispy Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 12.75     ,
      img: '/images/No_image.JPG',
      desc: '2 pcs of shrimp tempura, carb stick, avocado, cucumber, rolled in tempura crumbs {unagi sauce}',
      },
      {
      id: 67,
      title: 'Crazy Spicy Tuna Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 15.50,
      img: '/images/No_image.JPG',
      desc: 'spicy mayo blend of tuna, fish egg, cucumber, sliced tuna on top {spicy sauce}',
      },
      {
      id: 68,
      title: 'Kamikaze Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 13.75,
      img: '/images/No_image.JPG',
      desc: '2 pcs of shrimp tumpura, asparagus, avocado, cucumber, on top spicy mayo blend of tuna and fish egg{spicy mayo}',
      },
      {
      id: 69,
      title: 'Las Vegas Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 14.75    ,
      img: '/images/No_image.JPG',
      desc: '2 pcs of shrimp tumpura, avocado, cucumber, crab meat, cream cheese and all around deep fried {unagi sauce}',
      },
      {
      id: 70,
      title: 'Hawaian Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 13.00,
      img: '/images/No_image.JPG',
      desc: 'California roll base covered with red tuna, white tuna, avocado',
      },
      {
      id: 71,
      title: 'MangoTango Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 13.00,
      img: '/images/No_image.JPG',
      desc: 'Mango, cucumber, avocado, crab meat, fish egg, cream cheese all around bread crumbs {unagi sauce & honey mango sauce}',
      },
      {
      id: 72,
      title: 'MangoPhila Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 14.50,
      img: '/images/No_image.JPG',
      desc: 'Salmon, cream cheese, avocado, cucumber, asparagus on top smoked salmon & mango slice {honey mango sauce}',
      },
      {
      id: 73,
      title: 'Volcano Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 15.50,
      img: '/images/No_image.JPG',
      desc: 'California roll base, scallop, squid, fish egg, spicy mayo on top served with baked crumbs, tobiko, green onion {unagi sauce}',
      },
      {
      id: 74,
      title: 'Crazy Spicy Shrimp roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 14.75,
      img: '/images/No_image.JPG',
      desc: 'Filling of avocado, two pieces of shrimp tempura, real crab, and cucumber topped with spicy shrimp and sliced jalapenos, tobik',
      },
      {
      id: 75,
      title: 'Green Dragon Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 14.75,
      img: '/images/No_image.JPG',
      desc: '2 pcs of shrimp tempura, avocado, cucumber, crab meat, fish egg, mayo, avocado on top {unagi sauce}',
      },
      {
      id: 76,
      title: 'Red Dragon Roll(8pcs)',
      category: 'SPECIAL ROLLS',
      price: 16.00,
      img: '/images/No_image.JPG',
      desc: '2 pcs of shrimp tempura, avocado, cucumber, crab meat, fish egg, mayo, sockeye salmon on top {unagi sauce}',
      },
      {
    id: 80,
    title: 'Romeo and Juliet Roll(8pcs)',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 17.50,
    img: '/images/No_image.JPG',
    desc: '2 pcs of shrimp tempura, real crab, avocado, cucumber, fish egg, mayo, tobiko, salmon and tuna on top {honey mango sauce and unagi sauce}',
    },
    {
    id: 81,
    title: 'Pearl from Japan Roll(8pcs)',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 16.75,
    img: '/images/No_image.JPG',
    desc: ' red crab, avocado, japanese radish, cream cheese, topped with 8pcs of scallop tempura, tobiko {honey mango sauce}',
    },
    {
    id: 82,
    title: 'TNT Roll(8pcs)',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 15.50,
    img: '/images/No_image.JPG',
    desc: 'Real crab california roll base topped with scallop, tobiko, spicy mayo crumb mixed,  torched on top',
    },
    {
    id: 83,
    title: 'Seafood Paradise Roll(8pcs)',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 16.00,
    img: '/images/No_image.JPG',
    desc: '2Pcs of shrimp Tempura, avocado, real crab, cucumber, topped with sea food Tempura, tobiko {honey mango sauce, unagi sauce}',
    },
    {
    id: 84,
    title: 'Fire Mountain roll(6pcs)',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 15.50,
    img: '/images/No_image.JPG',
    desc: 'Assorted sashimi & topped with green onion, sesame oil, red tobiko',
    },
    {
    id: 85,
    title: 'Sushi Academy House Roll (8pcs)',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 17.50,
    img: '/images/No_image.JPG',
    desc: 'Salmon, tuna, sockeye salmon, scallop, red snapper, cucumber, mayo, topped with tobiko',
    },
    {
    id: 86,
    title: 'Sea Monster(8pcs)',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 21.50,
    img: '/images/No_image.JPG',
    desc: '2Pcs of shrimp Tempura, soft shell crab, avocado, cucumber, crab stick, with tempura crumbs, sweet mayo',
    },
    {
    id: 87,
    title: 'Moonlight River………………… $17',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 17.00,
    img: '/images/No_image.JPG',
    desc: 'Shrimp Tempura, Avocado, Fresh Mango, Tobiko,BBQ Eel on top,Unagi sauce',
    },
    {
    id: 88,
    title: 'Tokyo Night Maki ……………',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 16.50,
    img: '/images/No_image.JPG',
    desc: 'Tempura shrimp, Fresh Salmon Red tuna , Avocado, Cucmber, Tobiko,Mayo,Siracha',
    },
    {
    id: 89,
    title: 'Gerutzu………',
    category: 'CHEF’S NEW SPECIAL ROLLS',
    price: 17.50,
    img: '/images/No_image.JPG',
    desc: 'Tempura shrimp, Fresh Mango, Avocado,Red Tobiko,Snow Crab Meat,spicy Mayo with scallop Torch on top, sweet mango mayo',
    },
    {
    id: 90,
    title: 'California Roll (6pcs)',
    category: 'REGULAR ROLLS',
    price:  5.75,
    img: '/images/No_image.JPG',
    desc: 'Avocado, crab stick, cucumber, fish egg, mayo',
    },
    {
    id: 91,
    title: 'Real Crab California Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price: 7.25,
    img: '/images/No_image.JPG',
    desc: 'Real crab, avocado, cucumber, fish egg, mayo',
    },
    {
    id: 92,
    title: 'Salmon California Roll (6pcs)',
    category: 'REGULAR ROLLS',
    price: 7.25,
    img: '/images/No_image.JPG',
    desc: 'Salmon, avocado, cucumber, fish egg, mayo',
    },
    {
    id: 93,
    title: 'Tuna California Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price: 7.25,
    img: '/images/No_image.JPG',
    desc: 'Tuna, avocado, cucumber, fish egg, mayo',
    },
    {
    id: 94,
    title: 'Deep fried Spicy California Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price: 9.95,
    img: '/images/No_image.JPG',
    desc: 'Avocado, crab stick, cucumber, cream cheese, fish egg, spicy mayo all around deep fried {unagi sauce}',
    },
    {
    id: 95,
    title: 'Dynamite Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price: 7.00,
    img: '/images/No_image.JPG',
    desc: '2pcs of tempura shrimp, cucumber, fish egg, mayo {unagi sauce}',
    },
    {
    id: 96,
    title: 'Philadelphia Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'Raw salmon, Philadelphia cream cheese, cucumber',
    },
    {
    id: 97,
    title: 'Bagel Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'Smoked salmon, Philadelphia cream cheese, cucumber',
    },
    {
    id: 98,
    title: 'Alaska Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price: 7.25,
    img: '/images/No_image.JPG',
    desc: 'Salmon, avocado, fish egg, mayo',
    },
    {
    id: 99,
    title: 'Peanut Beef Roll(5pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'Grilled beef, peanut butter, cucumber',
    },
    {
    id: 100,
    title: 'Chop Scallop Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price: 7.00,
    img: '/images/No_image.JPG',
    desc: 'Chopped scallop, mayo, fish egg, crumb',
    },
    {
    id: 101,
    title: 'Unagi Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'BBQ eel, cucumber, avocado',
    },
    {
    id: 102,
    title: 'Ikaten Roll(5pcs)',
    category: 'REGULAR ROLLS',
    price: 7.00,
    img: '/images/No_image.JPG',
    desc: 'Deep fried squid (calamari), cucumber {unagi sauce}, {teriyaki}',
    },
    {
    id: 103,
    title: 'Teriyaki Chicken Roll(5pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'Deep fried chicken, cucumber {teriyaki sauce}',
    },
    {
    id: 104,
    title: 'Teriyaki Beef Roll(5pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'Grilled beef, cucumber {teriyaki sauce}',
    },
    {
    id: 105,
    title: 'Teriyaki Salmon Roll(5pcs)',
    category: 'REGULAR ROLLS',
    price: 7.00,
    img: '/images/No_image.JPG',
    desc: 'Deep fried salmon with teriyaki, cucumber {teriyaki sauce}',
    },
    {
    id: 106,
    title: 'Baku Dan Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price: 7.25,
    img: '/images/No_image.JPG',
    desc: 'Spicy tuna blend with tempura crumbs  (or salmon), {spicy}',
    },
    {
    id: 107,
    title: 'Spicy Tuna Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price:  7.25,
    img: '/images/No_image.JPG',
    desc: 'Spicy mayo tuna blend, tempura crumbs, fish egg',
    },
    {
    id: 108,
    title: 'Spicy Salmon Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price:  7.25,
    img: '/images/No_image.JPG',
    desc: 'Spicy mayo salmon blend, crumbs, fish egg',
    },
    {
    id: 109,
    title: 'Spicy Crab Roll(6pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'Spicy mayo crab stick, tempura crumbs, fish egg, cucumber',
    },
    {
    id: 110,
    title: 'Spicy Chicken Roll(5pcs)',
    category: 'REGULAR ROLLS',
    price:  7.00,
    img: '/images/No_image.JPG',
    desc: 'Deep fried chicken, special spicy sauce, {maki style}',
    },
    {
    id: 111,
    title: 'Sushi Maki(6pcs)',
    category: 'REGULAR ROLLS',
    price: 5.50,
    img: '/images/No_image.JPG',
    desc: 'Choice [Negi toro / Tuna / Salmon / Smoked salmon]',
    },
    {
    id: 120,
    title: 'Yam Roll(special(8pcs)',
    category: 'VEGETARIAN',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: 'Fried yam stick, covered yam tempura',
    },
    {
    id: 121,
    title: 'Avocado Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 5.50,
    img: '/images/No_image.JPG',
    desc: 'Avocado',
    },
    {
    id: 122,
    title: 'Avocado Mango Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 5.50,
    img: '/images/No_image.JPG',
    desc: 'Avocado, mango',
    },
    {
    id: 123,
    title: 'Cucumber Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 5.50,
    img: '/images/No_image.JPG',
    desc: 'Cucumber',
    },
    {
    id: 124,
    title: 'Avocado Cucumber Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 5.50,
    img: '/images/No_image.JPG',
    desc: 'Avocado, cucumber',
    },
    {
    id: 125,
    title: 'Avocado Shitake Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 5.50,
    img: '/images/No_image.JPG',
    desc: 'Avocado, shitake mushroom',
    },
    {
    id: 126,
    title: 'Vegetable Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: 'Avocado, cucumber, asparagus, carrot',
    },
    {
    id: 127,
    title: 'Zucchini Fry Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: 'Zucchini tempura, asparagus, cucumber,cream cheese',
    },
    {
    id: 128,
    title: 'Eggplant Fry Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: 'Eggplant tempura, asparagus, cucumber, cream cheese',
    },
    {
    id: 129,
    title: 'Spinach Roll(6pcs)',
    category: 'VEGETARIAN',
    price: 6.50,
    img: '/images/No_image.JPG',
    desc: 'Boiled spinach, sweet sesame sauce',
    },
    {
    id: 130,
    title: 'Tropical Veggie Roll(8pcs)',
    category: 'VEGETARIAN',
    price: 13.20    ,
    img: '/images/No_image.JPG',
    desc: 'Mango, cucumber, avocado, asparagus, red pepper, carrot wrapped in soybean paper {honey mango sauce}',
    },
    {
    id: 131,
    title: 'Veggie Dragon Roll(8pcs)',
    category: 'VEGETARIAN',
    price: 14.00,
    img: '/images/No_image.JPG',
    desc: 'Mango, cucumber, avocado, asparagus, red pepper, carrot topped with avocado and mango slices   {honey mango sauce}',
    },
    {
    id: 132,
    title: 'Japanese garden roll(8pcs)',
    category: 'VEGETARIAN',
    price: 12.50,
    img: '/images/No_image.JPG',
    desc: 'Deep fried yam and zucchini , avocado, cucumber, asparagus, cream cheese. {maki style vegetarian}',
    },
    {
    id: 133,
    title: 'Vegetable Sushi Maki(6pcs)',
    category: 'VEGETARIAN',
    price: 4.50,
    img: '/images/No_image.JPG',
    desc: 'Choice [ avocado / cucumber / asparagus / carrot / shitake mushroom ]',
    },
    {
    id: 140,
    title: 'Banana tempura (6pcs)',
    category: 'DESSERT',
    price: 4.50,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 141,
    title: 'Ice Cream',
    category: 'DESSERT',
    price: 3.75,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 142,
    title: 'Banana tempura with ice cream',
    category: 'DESSERT',
    price: 6.75,
    img: '/images/No_image.JPG',
    desc: '',
    },
    {
    id: 150,
    title: 'Canned Pop(335ml)',
    category: 'BEVERAGE',
    price: 2.50,
    img: '/images/No_image.JPG',
    desc: 'Coke / Diet Coke / Sprite / Coke zero / Ginger Ale / ice tea / Fanta or Orange Crush',
    },
    {
    id: 151,
    title: 'Ramune carbonated Japanese soft Drink (200ml)',
    category: 'BEVERAGE',
    price: 3.99,
    img: '/images/No_image.JPG',
    desc: 'Orange / Lemonade / Melon / Grapefruit / Blueberry',
    },
    {
    id: 152,
    title: 'Tropicana Juice(355ml)',
    category: 'BEVERAGE',
    price: 3.75,
    img: '/images/No_image.JPG',
    desc: 'Apple / Orange',
    },
    {
    id: 153,
    title: 'Japanese Green Tea(Per Pot)',
    category: 'BEVERAGE',
    price: 4.00,
    img: '/images/No_image.JPG',
    desc: '',
    }                             
];
export default MenuData;